import React, { useCallback } from 'react';
import { Controller } from 'react-hook-form';

import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import LabelName from 'components/UI/LabelName/LabelName';
import CaseSelect from 'components/UI/CaseSelect/CaseSelect';
import { toSelectValue } from 'utils/utils';

function CaseName({ isFromClientDashboard, control, errors }) {
  const handleChange = useCallback(
    (field) => (selected) => {
      field.onChange(selected ? { ...selected, id: selected.value ?? selected.case_id } : null);
    },
    []
  );

  return (
    <div className="case-search-wrapper d-flex py-2 flex-wrap file-manager-case-wrap align-items-center">
      <div className="col-md-3 col-12">
        <LabelName required htmlFor="case" className="mt-2">
          Case/Lead
        </LabelName>
      </div>
      <div className="col-md-9 col-12">
        <Controller
          name="case"
          control={control}
          rules={{
            required: true,
            validate: (value) => typeof value === 'object' && value !== null,
          }}
          render={({ field }) => (
            <CaseSelect
              name="case"
              placeholder="Search case/lead..."
              isClearable={false}
              isDisabled={isFromClientDashboard}
              value={toSelectValue(field?.value)}
              onChange={handleChange(field)}
            />
          )}
        />
        {errors?.case?.type === 'required' && <InputErrorMessage>Please select case/lead</InputErrorMessage>}
        {errors?.case?.type === 'validate' && <InputErrorMessage>Please select valid case/lead</InputErrorMessage>}
      </div>
    </div>
  );
}

export default CaseName;
